import React from 'react'
import PropTypes from 'prop-types'

// wrong spelling "advrtismnt" to avoid ad blocker blocking advertisement
const DhsvPostAdv = ({ data }) => {
  return (
    <div className="blog-item post-advrtismnt">
      <div className="inner">
        <a
          href={data.link.url}
          className="image-advrtismnt lazyload"
          {...(data.thumbnail ? { 'data-bg': data.thumbnail } : {})}
        />
      </div>
    </div>
  )
}

DhsvPostAdv.propTypes = {
  data: PropTypes.object,
}

export default DhsvPostAdv
